









































import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import FactorScoringDefinitionCreator from "@/components/scoring-definition/FactorScoringDefinitionCreator.vue";

@Component({
    components: {FactorScoringDefinitionCreator}
})
export default class FactorScoringDefinitionCreatorDialog extends Vue {

    @Model("updated:scoringDefinition")
    scoringDefinition!: any;

    @Prop()
    defaultScoringKeys!: any[];

    @Prop()
    name!: string;

    @Prop()
    inheritedFromName!: string;

    @Prop({})
    valueType!: string;

    @Prop({})
    categoricalValues!: string[]

    @Prop({})
    choiceValues!: any[]

    @Prop({default: false})
    loading!: boolean;

    @Prop({default: false})
    deleteEnabled!: boolean

    @Prop({default: false, type: Boolean})
    small: boolean;

    @Prop({default: false, type: Boolean})
    xSmall: boolean;

    private rerenderKey = 1;

    private show = false;

    mounted() {

    }

    @Watch('defaultScoringKeys')
    @Watch('scoringDefinition')
    onDefaultScoringKeysChange() {
        this.rerenderKey++;
    }

    @Emit('updated:scoringDefinition')
    @Emit('submit')
    private submit(scoringDefinition: any) {
        this.show = false;
        return scoringDefinition;
    }

    @Emit('delete')
    private deleteClick() {
        this.show = false;
    }

}
